import { AuthenticatedLayout } from "../../layouts";
import { CRARamittanceSetup } from "../../components/CRARamittanceSetup";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";

export const CRARamittanceSetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="CRA"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "CRA", navigateTo: "/taxes/remittance/cra" },
      ]}
      mainContents={<CRARamittanceSetup />}
    />
  );
};
